export default "__VITE_ASSET__DwS2m5f0__"